// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"89f2796a","648":"8dcada65"}[chunkId] + ".chunk.js";
};